// jshint asi: true
// jshint devel: true
// jshint unused:false

// @codekit-prepend "scripts/activateChildren.js"
// @codekit-prepend "scripts/clickTransition.js"
// @codekit-prepend "scripts/menuToggle.js"
// @codekit-prepend "scripts/sliders.js"
// @codekit-prepend "scripts/form.js"

$(document).ready(function() {

	activateChildren()
	clickTransition()
	menuToggle()
	sliders()

	/* Plan de Carreras fx */
	$('.plan_btn_JS').click(function () {
		$(this).parent('.plan_item_JS').toggleClass('active')
	})
	$('.plan_all_JS').click(function () {
		$('.plan_item_JS').addClass('active')
	})

	/* Modales Becas fx */
	$('.beca_btn_JS').click(function () {
		var item = $(this).data('item')
		$('.beca_JS').hide()
		$('.beca_JS[data-item="'+item+'"]').fadeIn()
	})
	$('.beca_close_JS').click(function () {
		$('.beca_JS').fadeOut()
	})
	$('.banner_close_JS').click(function () {
		$('.banner_JS').fadeOut()
	})

	$('.carrera_btn_JS').click(function () {
		$('html, body').animate({ scrollTop: $('.carrera_plan_JS').offset().top }, 650);
	})

	/* Home Hero Hover fx */
	$('.hero_txt_JS').click(function(e) {
		e.preventDefault()
	})
	$('.hero_txt_JS a').hover(
		function() {
			var img = $(this).attr('href')
			$('.hero_JS').css('background-image','url('+img+')')
		}, function() {
			var bg = $('.hero_JS').data('bg')
			$('.hero_JS').css('background-image','url('+bg+')')
		}
	)

	$('[data-href]').click(function(e) {
		e.preventDefault()
		var href = $(this).data('href')
		window.location.href = href;
	})

})

$(window).scroll(function () {
	activateChildren()

	var fix = 60 - $(window).scrollTop()
	var fixm = 36 - $(window).scrollTop()
	if ($(window).width() > 720) {
		if (fix > 0) {
			$('.menu_JS').css('top',fix+'px')
		} else {
			$('.menu_JS').css('top','0')
		}
	} else {
		if (fixm > 0) {
			$('.menu_JS').css('top',fixm+'px')
		} else {
			$('.menu_JS').css('top','0')
		}
	}

})

$(window).resize(function () { 
	// $(window).width() > 1080 ? '' : menuClose('x') //jshint ignore:line
})

var ua = navigator.userAgent.toLowerCase()
if (ua.indexOf('safari') !== -1) { 
	if (ua.indexOf('chrome') > -1) {} else {
		window.onpageshow = function(event) {
			if (event.persisted) {
				window.location.reload() 
			}
		}
	}
}
